export enum UrlTypes {
  Setting = 'setting',
  MainPages = 'main-pages',
  News = 'news',
  Login = 'login',
  AddWallet = 'add-wallet',
  ListOfWallet = 'list-of-wallet',
  Register = 'register'
}
